import './DisabledFormPart.css';

export function DisabledFormPart({
	isDisabled,
	children,
	onClick,
}: {
	isDisabled: boolean;
	children: React.ReactNode;
	onClick?: () => void;
}) {
	return (
		<div className={isDisabled ? 'disabled-form-part disabled' : 'disabled-form-part'}>
			{isDisabled && <button onClick={onClick} className={'disabled-form-btn'}></button>}
			{children}
		</div>
	);
}
